<template>
  <div>
    <Lista></Lista>
  </div>
</template>

<script>
import Lista from "@/components/Reportes/Lista";
export default {
  components: {
    Lista
  }
};
</script>

<style>
</style>